import {interviewAccountReturnUuid} from "./InterviewAccountReturn.js";
import AccountApi from "../api/AccountApi.js";
import {getRecaptchaToken} from "./reCAPTCHA.js";
import {useAccountStore} from "../stores/AccountStore.js";
import {gtagNewUser} from "./GoogleAnalytics.js";

export const sendSMSVerificationCode = async (phone, callback, ignoreUserId = undefined, mustBeUnique = true) => {
  let recaptchaToken = await getRecaptchaToken("sms");
  await AccountApi.sendVerificationSms({
    phone: phone,
    ignore: ignoreUserId,
    must_be_unique: mustBeUnique,
    "g-recaptcha-response": recaptchaToken,
  })
    .then((res) => {
      if (res?.error) toast.error(res.error);
      callback(res?.message === "success");
    })
    .catch((err) => {
      callback(false, err);
    });
};

export const checkIfEmailExists = async (email) => {
  try {
    let response = await AccountApi.checkIfEmailExists({
      email: email,
      ...(interviewAccountReturnUuid() ? {interview_uuid: interviewAccountReturnUuid()} : {}),
    });

    if (response.exists && response.headless) toast.info("Great news! Your email was already used to apply for a job on Business Draft. We just resent the email to claim your account.");
    return response.exists;
  } catch (error) {
    console.error(error);
    return true;
  }
};

export const checkIfUsernameTaken = async (username) => {
  try {
    let response = await AccountApi.checkIfUsernameTaken({
      username: username,
    });

    return {
      taken: response?.is_taken,
      valid: response?.is_valid,
      reason: response?.reason,
    };
  } catch (error) {
    console.error(error);
    return {
      taken: false,
      valid: false,
    };
  }
};

export const registerUser = async (
  user,
  createCompany,
  inviteCode,
  callback,
  setResId,
  userFirst,
  showProgressBar = true
) => {
  const navigatorLanguage = navigator.language || navigator.userLanguage;

  if (showProgressBar) window.progressBar.start();
  await AccountApi.registerUser({
    ...user,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: navigatorLanguage,
    create_company: createCompany,
    acquisition_source: localStorage.getItem("acquisition_source") || "",
  })
    .then((res) => {
      let wasSuccessful = !!res.id;
      setResId(res.id);

      if (wasSuccessful) gtagNewUser(res.id);

      callback(wasSuccessful);
      if (wasSuccessful) toast.success("Welcome to Business Draft, " + userFirst + "!");
    })
    .catch((err) => callback(false, err))
    .finally(() => {
      const accountStore = useAccountStore();
      accountStore.fetchUserAccount();
      if (showProgressBar) window.progressBar.complete();
    });
};

export const validateField = (
  isValid,
  notifyUserOnError,
  messageIfNotValid,
  errorCallback,
  successCallback
) => {
  if (!isValid) {
    if (notifyUserOnError) {
      toast.warning(messageIfNotValid);
      errorCallback(messageIfNotValid);
    }
    return false;
  } else {
    successCallback();
    return true;
  }
};
